import React from 'react'

import SanityLink from '../../SanityLink'
import { FooterMenuEntry } from '../FooterLinks'

export interface FooterLinksGroupProps {
  className?: string
  heading?: string
  section?: string
  links: FooterMenuEntry[]
}

const FooterLinksGroup: React.FC<FooterLinksGroupProps> = ({
  className,
  links,
  heading,
  section,
}) => {
  return (
    <nav className={className} aria-label={section}>
      <ul className="[&_li]:mb-2 overflow-visible break-words">
        {heading ? <li className="font-medium text-sm">{heading}</li> : null}
        {links.map((item, index) => (
          <li key={index} className="font-normal [&_button]:!text-white [&_button]:!font-normal">
            <SanityLink className="no-underline lg:hover:underline" to={item.link || undefined}>
              {item.name}
            </SanityLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export { FooterLinksGroup }
